<div class="chips-container">
    <div *ngFor="let chipsItem of chips;let i = index;"
    (click)="handleClick(i)"
    class="container"
    [ngStyle]="{
        'border-color': isSelected(chipsItem) ? getPrimaryColor(chipsItem) : '#e0e0e0',
        'background-color' : isSelected(chipsItem) ? getSecondaryColor(chipsItem) : '#fff'
    }"
    [ngClass]="{
        'not-selected':!isSelected(chipsItem),
        'disabled': isDisabled(chipsItem)
    }"
    >

    <div class="svg-icon" [innerHTML]="getSvg(CHECK_ICON, i) | sanitizeHtml " *ngIf="chipsItem.isSelected"></div>
    <div class="svg-icon" [innerHTML]="CHECK_EMPTY_ICON | sanitizeHtml "  *ngIf="!chipsItem.isSelected || chipsItem.isDisabled"></div>
    <span [ngStyle]="{
        color : isSelected(chipsItem) ? getPrimaryColor(chipsItem) : '#181F33'
    }"
    class="chips-value"
    >
        {{chipsItem.label}}: {{chipsItem.value}}
     </span> 
    </div>

</div>